import { render, staticRenderFns } from "./drawer_selectProduct.vue?vue&type=template&id=397f147f&scoped=true&"
import script from "./drawer_selectProduct.vue?vue&type=script&lang=js&"
export * from "./drawer_selectProduct.vue?vue&type=script&lang=js&"
import style0 from "./drawer_selectProduct.vue?vue&type=style&index=0&id=397f147f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f147f",
  null
  
)

export default component.exports